<template>
  <div class="tour-wizard">
    <div class="tour-wizard__wrapper">
      <header class="tour-wizard__header">
        <router-link to="/" class="tour-wizard__header--logo">
          <img src="../../assets/img/svg/logo.svg" alt=" " />
        </router-link>
        <div id="tourName" class="tour-wizard__header--tour-name">{{ tour.name }}</div>
        <button class="tour-wizard__header--exit" aria-label="Exit tour" @click.prevent.stop="exit()">
          <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="xmark" class="svg-inline--fa fa-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
            <path fill="currentColor" d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"></path>
          </svg>
        </button>
      </header>
      <section class="tour-wizard__slides--rail"
               aria-labelledby="tourName"
               @touchstart="touchStart">
        <div class="tour-wizard__slides"
             v-bind:style="{ width: sliderTotalWidth, left: sliderLeftPosition }">
          <div class="tour-wizard__slide"
               role="group"
               aria-labelledby="tourPagination"
               :class="[{ active: currentSlide === index + 1 }]"
               v-bind:style="{ maxWidth: slideMaxWidth }"
               v-for="(slide, index) in this.tour.slides">
            <div class="tour-wizard__slide--media"
                 :class="['type-' + (slide.media.type || 'image') ]">
              <template v-if="slide.media.type === 'image'">
                <img :src="slide.media.resource" :alt="slide.media.alt || ' '" />
              </template>
              <template v-if="slide.media.type === 'video'">
                <video loop controls :title="slide.media.title || ''">
                  <source :src="source.src"
                          :type="source.type || 'video/mp4'"
                          v-for="source in slide.media.sources">
                </video>
              </template>
            </div>
            <div class="tour-wizard__slide--text">
              <div class="tour-wizard__slide--text__wrapper">
                <h1 class="tour-wizard__slide--text__title" v-html="slide.title"></h1>
                <div class="tour-wizard__slide--text__text" v-html="slide.text"></div>
                <div class="tour-wizard__slide--text__hint" v-if="index === 0">
                  <div>
                    <svg aria-hidden="true" focusable="false" role="img" id="swipe" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="31.14" height="32" viewBox="0 0 31.14 32">
                      <defs>
                        <clipPath id="clip-path">
                          <rect id="Rectangle_1482" data-name="Rectangle 1482" width="31.14" height="32" fill="currentColor"/>
                        </clipPath>
                      </defs>
                      <g id="Group_13162" data-name="Group 13162" clip-path="url(#clip-path)">
                        <path id="Path_11133" data-name="Path 11133" d="M167.585,93.256a3.083,3.083,0,0,0-.359.022,2.937,2.937,0,0,0-1.263.461,2.769,2.769,0,0,0-.105-.262A3,3,0,0,0,164.8,92.24a2.977,2.977,0,0,0-3.262-.037,3.018,3.018,0,0,0-1.358-1.691,2.931,2.931,0,0,0-1.12-.373,3.027,3.027,0,0,0-.359-.022,2.985,2.985,0,0,0-.6.062,2.933,2.933,0,0,0-.854.319V88.378a2.98,2.98,0,0,0-2.982-3.018,2.985,2.985,0,0,0-2.982,2.982v6.549c0,1.162,0,2.37,0,3.527a3.616,3.616,0,0,0-2.971-1.674h-.221l-.213.06a2.985,2.985,0,0,0-2.063,3.674l1.444,5.25c.315,1.146.392,1.34.425,1.424,1.578,3.992,5.588,6.25,11.6,6.529l.037,0h.132a14.8,14.8,0,0,0,4.4-.633,10.84,10.84,0,0,0,3.494-1.8,8.112,8.112,0,0,0,3.22-6.286c0-.034,0-.2,0-1.366s0-3.329,0-7.357a2.986,2.986,0,0,0-2.982-2.982m1.378,11.675c-.075,3.955-3.709,7.148-9.512,7.148h-.1c-4.1-.191-8.563-1.427-10.18-5.518-.077-.195-.327-1.1-.37-1.259l-1.445-5.254a1.384,1.384,0,0,1,.954-1.7,2.009,2.009,0,0,1,1.822,1.38l1.252,4.447c.009.031.02.062.032.093a.76.76,0,0,0,.709.487h0a.757.757,0,0,0,.757-.757c0-.886,0-5.464,0-9.442,0-.731,0-1.442,0-2.106V88.342a1.382,1.382,0,0,1,1.548-1.37,1.4,1.4,0,0,1,1.212,1.406v10.3a.84.84,0,0,0,1.681,0V93.1a1.384,1.384,0,0,1,1.38-1.38,1.411,1.411,0,0,1,.168.01,1.331,1.331,0,0,1,.561.2,1.434,1.434,0,0,1,.65,1.2v6.306a.84.84,0,0,0,1.681,0V94.716a1.38,1.38,0,0,1,2.759,0v5.963a.84.84,0,1,0,1.681,0v-4.4a1.383,1.383,0,0,1,1.379-1.416,1.384,1.384,0,0,1,1.38,1.38s0,8.681,0,8.693" transform="translate(-139.427 -81.682)" fill="currentColor"/>
                        <path id="Path_11134" data-name="Path 11134" d="M2.7,2.748,4.083,1.364A.8.8,0,0,0,4.1.239.791.791,0,0,0,2.979.232L.231,2.979h0Q.206,3,.184,3.031l-.026.034c-.008.011-.017.022-.025.034s-.014.023-.021.035l-.019.031C.087,3.177.081,3.19.076,3.2s-.011.022-.016.034-.009.024-.013.036S.038,3.3.034,3.309s-.006.024-.009.037-.007.025-.009.038,0,.029-.007.043,0,.022,0,.034a.8.8,0,0,0,0,.156c0,.011,0,.022,0,.034s0,.029.007.043.006.026.009.038,0,.022.008.032l0,0c0,.013.009.025.013.037s.008.024.013.036.01.022.016.033.011.025.018.037l.018.031c.007.012.014.024.022.036l.024.032c.007.01.014.02.023.03s.031.035.047.052L.231,4.1,2.964,6.831a.8.8,0,0,0,1.126.021A.791.791,0,0,0,4.1,5.727l-1.4-1.4h7.322a.791.791,0,0,0,0-1.581Z" transform="translate(0 0)" fill="currentColor"/>
                        <path id="Path_11135" data-name="Path 11135" d="M436.562,4.324l-1.383,1.383a.8.8,0,0,0-.021,1.126.791.791,0,0,0,1.125.007l2.748-2.748h0q.025-.025.047-.052c.008-.009.019-.024.026-.034s.017-.022.025-.034.014-.023.021-.035l.019-.031c.006-.012.012-.024.017-.036s.011-.022.016-.034.009-.024.013-.036.009-.024.013-.037.006-.024.009-.037.007-.025.009-.038,0-.029.006-.043,0-.022,0-.034a.8.8,0,0,0,0-.156c0-.011,0-.022,0-.034s0-.029-.006-.043-.006-.026-.009-.038,0-.022-.008-.032l0,0c0-.013-.009-.025-.013-.037s-.008-.024-.013-.036-.01-.022-.016-.033-.011-.025-.018-.037-.012-.02-.018-.031-.014-.024-.022-.036l-.023-.032-.023-.03c-.015-.018-.031-.035-.047-.052l-.005-.006L436.3.241A.8.8,0,0,0,435.171.22a.791.791,0,0,0-.007,1.125l1.4,1.4H429.24a.791.791,0,0,0,0,1.581Z" transform="translate(-409.987 0)" fill="currentColor"/>
                      </g>
                    </svg>
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="square-arrow-left" class="svg-inline--fa fa-square-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M336 240H150.6l68.69-68.69c6.25-6.25 6.25-16.38 0-22.62s-16.38-6.25-22.62 0l-96 96C97.56 247.8 96 251.9 96 256s1.562 8.184 4.688 11.31l96 96c6.25 6.25 16.38 6.25 22.62 0s6.25-16.38 0-22.62L150.6 272H336c8.844 0 16-7.154 16-15.1C352 247.2 344.8 240 336 240zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"></path></svg>
                    <svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="square-arrow-right" class="svg-inline--fa fa-square-arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M251.3 148.7c-6.25-6.25-16.38-6.25-22.62 0s-6.25 16.38 0 22.62L297.4 240H112C103.2 240 96 247.2 96 255.1C96 264.8 103.2 272 112 272h185.4l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.62s16.38 6.25 22.62 0l96-96C350.4 264.2 352 260.1 352 255.1s-1.562-8.184-4.688-11.31L251.3 148.7zM384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM416 416c0 17.64-14.36 32-32 32H64c-17.64 0-32-14.36-32-32V96c0-17.64 14.36-32 32-32h320c17.64 0 32 14.36 32 32V416z"></path></svg>
                  </div>
                  <div>
                    Navigate this slider by using the arrows on your keyboard or by clicking on the previous and next buttons below. If you are on a mobile device, swipe left/right.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <footer class="tour-wizard__footer">
        <div class="tour-wizard__pagination">
          <div class="tour-wizard__pagination--previous">
            <button @click.prevent.stop="previous()" :disabled="!canGoToThePrevious" v-bind:aria-disabled="!canGoToThePrevious">
              <span>
                <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-left" class="svg-inline--fa fa-arrow-left" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                  <path fill="currentColor" d="M447.1 256c0 13.25-10.76 24.01-24.01 24.01H83.9l132.7 126.6c9.625 9.156 9.969 24.41 .8125 33.94c-9.156 9.594-24.34 9.938-33.94 .8125l-176-168C2.695 268.9 .0078 262.6 .0078 256S2.695 243.2 7.445 238.6l176-168C193 61.51 208.2 61.85 217.4 71.45c9.156 9.5 8.812 24.75-.8125 33.94l-132.7 126.6h340.1C437.2 232 447.1 242.8 447.1 256z"></path>
                </svg>
                {{ previousButtonText }}
              </span>
            </button>
          </div>
          <div id="tourPagination"
               aria-live="polite"
               class="tour-wizard__pagination--controls"
               v-bind:aria-labelledby="'Slide ' + currentSlide + ' of ' + totalSlides">
            {{ currentSlide }}/{{ totalSlides }}
          </div>
          <div class="tour-wizard__pagination--next">
            <button @click.prevent.stop="canGoToTheNext ? next() : exit()" :class="[{ exit: !canGoToTheNext }]">
              <span>
                <template v-if="canGoToTheNext">
                  {{ nextButtonText }}
                  <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="arrow-right" class="svg-inline--fa fa-arrow-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path fill="currentColor" d="M264.6 70.63l176 168c4.75 4.531 7.438 10.81 7.438 17.38s-2.688 12.84-7.438 17.38l-176 168c-9.594 9.125-24.78 8.781-33.94-.8125c-9.156-9.5-8.812-24.75 .8125-33.94l132.7-126.6H24.01c-13.25 0-24.01-10.76-24.01-24.01s10.76-23.99 24.01-23.99h340.1l-132.7-126.6C221.8 96.23 221.5 80.98 230.6 71.45C239.8 61.85 254.1 61.51 264.6 70.63z"></path>
                  </svg>
                </template>
                <template v-else>
                  <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="xmark" class="svg-inline--fa fa-xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path fill="currentColor" d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"></path>
                  </svg>
                  Exit tour
                </template>
              </span>
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'tour-wizard',
    props: {
      tour: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        currentSlide: 1,
        sliderTotalWidth: 0,
        slideMaxWidth: 0,
        sliderLeftPosition: 0
      }
    },
    computed: {
      ...mapGetters([]),
      totalSlides () {
        if (!this.tour.slides) {
          return 0
        }
        return this.tour.slides.length
      },
      canGoToTheNext () {
        return this.tour.slides && this.currentSlide < this.tour.slides.length
      },
      canGoToThePrevious () {
        return this.tour.slides && this.currentSlide > 1
      },
      previousButtonText () {
        if (this.tour && this.tour.navigation && this.tour.navigation.previousBtnText) {
          return this.tour.navigation.previousBtnText
        }
        return 'Previous step'
      },
      nextButtonText () {
        if (this.tour && this.tour.navigation && this.tour.navigation.nextBtnText) {
          return this.tour.navigation.nextBtnText
        }
        return 'Next step'
      }
    },
    methods: {
      ...mapActions([]),
      next () {
        if (!this.canGoToTheNext) {
          return
        }
        this.currentSlide += 1
      },
      previous () {
        if (!this.canGoToThePrevious) {
          return
        }
        this.currentSlide -= 1
      },
      exit () {
        if (this.tour && this.tour.endpoint) {
          if (this.tour.endpoint.type === 'internal') {
            let props = this.$router.resolve(this.tour.endpoint.url)
            this.$router.push(props.href)
          } else {
            location.href = this.tour.endpoint.url
          }
        } else {
          let props = this.$router.resolve({
            name: 'user-app'
          })
          this.$router.push(props.href)
        }
      },
      handleKeydown (e) {
        switch (e.keyCode) {
          case 37:
            this.previous()
            break
          case 39:
            this.next()
            break
          case 27:
            this.exit()
            break
        }
      },
      touchStart (touchEvent) {
        if (touchEvent.changedTouches.length !== 1) {
          return
        }
        const posXStart = touchEvent.changedTouches[0].clientX
        const listener = (touchEvent) => this.touchEnd(touchEvent, posXStart)
        addEventListener('touchend', listener, { once: true })
        setTimeout(() => {
          removeEventListener('touchend', listener)
        }, 800)
      },
      touchEnd (touchEvent, posXStart) {
        if (touchEvent.changedTouches.length !== 1) {
          return
        }
        const diff = 200
        const posXEnd = touchEvent.changedTouches[0].clientX
        if (diff + posXStart < posXEnd) {
          this.previous()
        } else if (posXStart > posXEnd + diff) {
          this.next()
        }
      },
      calculateSliderTotalWidth () {
        this.sliderTotalWidth = `${document.body.clientWidth * this.totalSlides}px`
      },
      calculateSlideMaxWidth () {
        this.slideMaxWidth = `${document.body.clientWidth}px`
      },
      calculateSliderLeftPosition () {
        this.sliderLeftPosition = `${(document.body.clientWidth * (this.currentSlide - 1)) * -1}px`
      },
      calculateSliderHeight () {
        setTimeout(() => {
          let activeSlide = document.querySelector('.tour-wizard__slide.active')
          let slider = document.querySelector('.tour-wizard__slides')
          if (activeSlide && slider) {
            if (document.body.clientWidth > 1024) {
              slider.style.height = ''
            } else {
              slider.style.height = `${activeSlide.clientHeight}px`
            }
          }
        }, 100)
      }
    },
    components: {},
    beforeMount () {
      window.addEventListener('keydown', this.handleKeydown, null)
      window.addEventListener('resize', this.calculateSliderTotalWidth, null)
      window.addEventListener('resize', this.calculateSlideMaxWidth, null)
      window.addEventListener('resize', this.calculateSliderLeftPosition, null)
      window.addEventListener('resize', this.calculateSliderHeight, null)
    },
    created () {
      this.calculateSliderTotalWidth()
      this.calculateSlideMaxWidth()
      this.calculateSliderLeftPosition()
      this.calculateSliderHeight()
      let app = document.getElementById('app')
      app.style.position = 'relative'
      app.style.zIndex = '9999999999'
    },
    mounted () {},
    beforeDestroy () {
      window.removeEventListener('keydown', this.handleKeydown)
      window.removeEventListener('resize', this.calculateSliderTotalWidth)
      window.removeEventListener('resize', this.calculateSlideMaxWidth)
      window.removeEventListener('resize', this.calculateSliderLeftPosition)
      window.removeEventListener('resize', this.calculateSliderHeight)
      let app = document.getElementById('app')
      app.style.position = ''
      app.style.zIndex = ''
    },
    beforeUpdate () {
      this.calculateSliderTotalWidth()
      this.calculateSlideMaxWidth()
      this.calculateSliderLeftPosition()
      this.calculateSliderHeight()
    },
    watch: {
      'currentSlide' () {
        let activeSlide = document.querySelector('.tour-wizard__slide.active')
        if (activeSlide) {
          activeSlide.scrollTo(0, 0)
        }
        document.getElementById('app').scrollIntoView()
        this.$nextTick(() => {
          this.calculateSliderHeight()
          let video = document.querySelector('.tour-wizard__slide.active .tour-wizard__slide--media.type-video video')
          if (video) {
            video.currentTime = 0
            video.play()
          }
        })
      },
      tour: {
        immediate: true,
        handler (value) {
          if (value) {
            document.title = value.name + ' | Clear Assured'
          }
        }
      }
    }
  }
</script>

<style src="@/assets/scss/components/tour-wizard/tour-wizard.scss" lang="scss" scoped />



// WEBPACK FOOTER //
// TourWizard.vue?ef2951f8